import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import ShootingStarIcon from '../../icons/ShootingStarIcon';
import VideoIcon from '../../icons/UserMenu/VideoIcon';
import styles from './styles.module.scss';

/**
 * "Live sessions" / "Video readings" rows. HORO-10471.
 *
 * Shared because the redesigned promo modal (Figma 4481:20887 / 4481:14168)
 * now shows the same two rows as the waitlist page. Duplicating them would
 * mean the copy and icons could drift between the two places a user sees them
 * minutes apart.
 */
const LiveReadingsValueProps = ({ className }) => {
    const { t } = useTranslation();

    return (
        <ul className={classNames(styles.valueProps, className)}>
            <li className={styles.valueProp}>
                <ShootingStarIcon className={styles.valuePropIcon} aria-hidden="true" />
                <div className={styles.valuePropText}>
                    <span className={styles.valuePropTitle}>{t('liveReadings.valueProps.liveTitle')}</span>
                    <span className={styles.valuePropDesc}>{t('liveReadings.valueProps.liveDesc')}</span>
                </div>
            </li>
            <li className={styles.valueProp}>
                <VideoIcon className={styles.valuePropIcon} aria-hidden="true" />
                <div className={styles.valuePropText}>
                    <span className={styles.valuePropTitle}>{t('liveReadings.valueProps.videoTitle')}</span>
                    <span className={styles.valuePropDesc}>{t('liveReadings.valueProps.videoDesc')}</span>
                </div>
            </li>
        </ul>
    );
};

export default LiveReadingsValueProps;
